<div class="card flex align-center justify-flex-end box gaps-3">
  <div [class]="dateUnitType === DateUnitType.Weekly ? 'col-5' : 'col-4'">
    <span *ngIf="dateUnitType === DateUnitType.Weekly" class="text-nowrap small weight-medium text-400">{{ weeklyDateDisplay }}</span>
    <app-date-input
      *ngIf="dateUnitType !== DateUnitType.Weekly && dateUnitType !== DateUnitType.Yearly"
      [(ngModel)]="selectedDate"
      (ngModelChange)="onDateChange($event)"
      [selectYear]="dateUnitType === DateUnitType.Yearly"
      [selectMonthAndYear]="dateUnitType === DateUnitType.Monthly"
      [theme]="'fill'"
      [startView]="'multi-year'"
      [min]="min"
      [max]="max"
    ></app-date-input>

    <div *ngIf="dateUnitType === DateUnitType.Yearly" class="radius-1 flex align-center text-nowrap bg-100">
      <mat-form-field class="radius-1 bg-100">
        <app-icon size="xs" name="calendar" class="prefix text-400 bg-100 align-center"></app-icon>
        <mat-select 
          class="bg-100 small text-400 px-2"
          [(value)]="selectedYear" 
          (selectionChange)="onDateChange($event.value)"
        >
          <mat-option class="small text-400" *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="toggle-buttons">
    <mat-button-toggle-group class="toggle-group" [value]="dateUnitType" (change)="onDateUnitChange($event.value)">
      <mat-button-toggle *ngFor="let key of selectedOptions" [value]="options[key]">
        {{ ('shared.DurationToggle.' + key) | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
